import React, { useEffect, useState } from 'react';
import { node } from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SplashScreen from '../components/SplashScreen';
import { refreshToken } from '../redux/auth';
import { loggedUserInfo } from '../redux/auth/slice';
import { reset } from '../redux/hospital/slice';
import { AuthContext } from '../utils/helper';
import { auth } from '../services/firebase';
import { signInAnonymously, signOut } from 'firebase/auth';
const AuthProvider = ({ children }) => {
	const [isLoggedInSuccess, setIsLoggedIn] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	useEffect(() => {
		window.addEventListener('storage', handleStorageChange);
		return () => {
			window.removeEventListener('storage', handleStorageChange);
		};
	}, []);

	const handleStorageChange = (event) => {
		if (event.key === 'authToken' && event.newValue === null) {
			handleLogout();
		}
	};
	useEffect(() => {
		const loadAPI = async() => {
			const res = await refreshToken();
			if (res && !res.data.error) {
				setIsLoggedIn(true);
				const payload = res.data.data;
				dispatch(loggedUserInfo(payload));
				localStorage.setItem('authToken', payload && payload.access_token);
				const origin = location.pathname || '/';
				navigate(origin);
				setIsLoading(false);
				return;
			}
			setIsLoggedIn(false);
			setIsLoading(false);
		};
		loadAPI();
	}, []);

	const handleLogin = async() => {
		await signInAnonymously(auth);
		setIsLoggedIn(true);
		const origin = location.pathname || '/';
		navigate(origin);
	};

	const handleLogout = () => {
		setIsLoggedIn(null);
		dispatch(reset());
		signOut(auth);
		localStorage.removeItem('authToken');
	};

	const value = {
		isLoggedInSuccess,
		isLoading,
		onLogin: handleLogin,
		onLogout: handleLogout,
	};

	if (isLoading) return <SplashScreen />;

	return (
		<AuthContext.Provider value={value}>
			{children}
		</AuthContext.Provider>
	);
};

AuthProvider.propTypes = {
	children: node.isRequired,
};

export default AuthProvider;
